export default {
  loggingon: false,
  loginfailed: false,
  networkerror: '',
  loginerror: ''
}
